<template>
	<div>
		<p>
			The Hand / Finger Setup Module is for setting up the finger bones for characters, as well as the fingertip colliders and arousal triggers.
		</p>

		<b-img src="/images/importer/module-hand-finger/hand-finger-module-automatic.jpg"></b-img>
		<p>
			<span class="font-weight-bold">Initialize:</span> After setting up the Unity Avatar for the character, the only thing to do in this module is to press the Initialize
			button. This will set up the hand and finger configurations behind the scenes, and add fingertip colliders as children of each of the fingertip bones that were set in the Avatar. You may
			want to adjust the position and size of these fingertip colliders as needed, to better fit the size of your character's fingertips.
		</p>
	</div>
</template>

<script>
export default {
		name: 'HandAndFingerModule',
}
</script>
